import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import LegForm from "./LegComponents/LegForm";

import { useAddLegMutation } from "store/services/legApi";

const LegCreateScreen = () => {
  
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Legs", path: "/app/crm/leg/list" },
    { title: "New Leg" }
  ];

  const [createLeg, { isLoading: creatingLeg }] = useAddLegMutation();

  const handleAddLeg = async (data) => {
    try {
      const { _id } = await createLeg(data).unwrap();
      toast.success("Leg Created!");
      navigate(`/app/crm/leg/${_id}/detail`);
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Leg!"
      );
    }
  };

  useAppMeta("New Leg");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingLeg}>
      <BreadcrumbLayout.Paper>
        <LegForm isBusy={creatingLeg} onSubmit={handleAddLeg} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LegCreateScreen;
